<template>
  <div class="content">
    <div class="container">
      <div class="error">
        <h1 ref="error.main">{{main}}</h1>
        <!-- <h2 ref="error.header"
        :contenteditable="editable"
        v-on:change="test">{{header}}</h2> -->
        <a class="error__link"
           :href="!editMode && $router.resolve({ name: 'login' }).href"
           v-word:layout.passwordRecovery.link.backToLogin>
          Login page
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    // const initialData = {
    //   'error.main'
    // },
  },
  data() {
    return {
      main: 'Error 500',
      header: 'default header',
      editable: 'false',
    };
  },
  methods: {
    edit() {
      this.editable = 'true';
    },
    save() {
      this.editable = 'false';
      var res = {};
      for (var [refName, elem] of Object.entries(this.$refs)) {
        res[refName] = elem.innerHTML;
      }
    },
    test() {},
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Error.vue